import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import UserGroupService from '@/services/UserGroupService';
import UserGroupServiceStaging from '@/services/UserGroupServiceStaging';

export async function getUserGroup({ commit, state, rootState }, id) {
  if (state.userGroup) {
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'success',
    });
    return state.userGroup;
  }

  const isStaging = rootState.dashboard.isStaging;

  const service = isStaging ? UserGroupServiceStaging : UserGroupService;

  try {
    const userGroup = await service.company(id);

    commit(MUTATE_MULTIPLE, [{
      property: 'userGroup',
      with: userGroup,
    }, {
      property: 'requestStatus',
      with: 'success',
    }]);

    return userGroup;
  } catch (e) {
    console.error(e);
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'error',
    });
  }
}
